<template>
  <div class="developer-page">
    <a-spin :spinning="spinning">
      <div v-if="isModify" class="form-page">
        <a-form :form="form" @submit="handleSubmit">
          <a-row>
            <a-col>
              <div v-if="hasDeveloper" class="title">编辑账号信息</div>
              <div v-else class="title">开发者申请</div>
            </a-col>
          </a-row>
          <div style="margin-top: 20px">
            <a-form-item label="公司名称" :label-col="{ span: 2 }" :wrapper-col="{ span: 6 }">
              <span>{{companyName}}</span>
            </a-form-item>
            <a-form-item label="公司地址" :label-col="{ span: 2 }" :wrapper-col="{ span: 6 }">
              <a-input
                placeholder="请输入公司地址"
                v-decorator="['address', {rules: [{ required: true, message: '请输入有效地址' }] }]"
              />
            </a-form-item>
            <a-form-item label="营业执照号码" :label-col="{ span: 2 }" :wrapper-col="{ span: 6 }">
              <a-input
                placeholder="请输入营业执照号码"
                v-decorator="['businessLicense', {rules: [{ required: true, message: '请输入营业执照号码' }] }]"
              />
            </a-form-item>
            <a-form-item label="负责人" :label-col="{ span: 2 }" :wrapper-col="{ span: 6 }">
              <a-input
                placeholder="请输入负责人"
                v-decorator="['corporation', { rules: [{ required: true, message: '请输入负责人' }] }]"
              />
            </a-form-item>
            <a-form-item label="联系电话" :label-col="{ span: 2 }" :wrapper-col="{ span: 6 }">
              <a-input
                placeholder="请输入联系电话"
                v-decorator="['contactPhone', { rules: [{ required: true, message: '请输入联系电话' }] }]"
              />
            </a-form-item>
            <a-form-item label="E-mail" :label-col="{ span: 2 }" :wrapper-col="{ span: 6 }">
              <a-input
                placeholder="请输入E-mail"
                v-decorator="['email', { rules: [{
                type: 'email',
                message: '请输入正确的E-mail',
              },{ required: true, message: '请输入E-mail' }] }]"
              />
            </a-form-item>
            <a-form-item label="营业执照照片" :label-col="{ span: 2 }" :wrapper-col="{ span: 6 }">
              <a-upload
                name="file"
                :multiple="false"
                :action="uploadImageUrl"
                @change="handleUploadFileChange"
                :showUploadList="false"
                listType="picture-card"
                class="img-uploader"
              >
                <img v-if="businessLicenseImg" :src="businessLicenseImg" alt="businessLicenseImg" style="width: 320px" />
                <div v-else>
                  <a-icon type="plus"></a-icon>
                  <div class="ant-upload-text">上传图片</div>
                </div>
              </a-upload>
            </a-form-item>
          </div>
          <a-row>
          <a-col :offset="2">
            <a-space :size="middle" v-if="hasDeveloper">
              <div class="save" @click="handleSubmit">保存</div>
              <div class="cancel" @click="handleCancel">取消</div>
            </a-space>
            <a-space :size="middle" v-else>
              <div class="save" @click="handleSubmit">申请</div>
            </a-space>
          </a-col>
        </a-row>
        </a-form>
      </div>
      <div v-else class="form-page" >
        <a-form>
          <div justify="start" >
              <span class="title">账号信息</span>
              <span class="edit" @click="handleUpdate">
                <span class="iconfont">&#xe7e1;</span>
                修改
              </span>
          </div>
          <div class="viewPage" style="margin-top: 20px">
            <a-form-item label="审核状态" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
              <icon-font v-if="statusDescription==='通过'" type="icon-check-circle-fill" style="color: #52C41A;"></icon-font>
              <span :class="checkStatusClassObject">{{statusDescription}}</span>
            </a-form-item>
            <a-form-item label="公司名称" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
              <span>{{companyName}}</span>
            </a-form-item>
            <a-form-item label="公司地址" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
              <span>{{address}}</span>
            </a-form-item>
            <a-form-item label="营业执照号码" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
              <span>{{businessLicense}}</span>
            </a-form-item>
            <a-form-item label="负责人" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
              <span>{{corporation}}</span>
            </a-form-item>
            <a-form-item label="联系电话" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
              <span>{{contactPhone}}</span>
            </a-form-item>
            <a-form-item label="E-mail" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
              <span>{{email}}</span>
            </a-form-item>
            <a-form-item label="营业执照照片" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
              <img v-if="businessLicenseImg" :src="businessLicenseImg" alt="businessLicenseImg" style="width: 320px" />
              <span v-else>-</span>
            </a-form-item>
          </div>
        </a-form>
      </div>
    </a-spin>
  </div>
</template>

<script>
import {
  Row, Col, Spin,
} from 'ant-design-vue';
import { getDeveloper, createDeveloper, uploadDeveloper } from '@/services/modules/developer';

export default {
  name: 'Developer',
  components: {
    'a-row': Row,
    'a-col': Col,
    // 'a-button': Button,
    'a-spin': Spin,
  },
  data() {
    return {
      spinning: false,
      hasOperation: false,
      hasDeveloper: false,
      isModify: false,
      developerId: '',
      address: '',
      businessLicense: '',
      corporation: '',
      contactPhone: '',
      email: '',
      vaildStatus: 0,
      statusDescription: '',
      uploadImageUrl: `${process.env.VUE_APP_API_BASE_URL}/upload/uploadImage`,
      businessLicenseImg: '',
      companyName: '',
    };
  },
  computed: {
    checkStatusClassObject() {
      if (this.statusDescription === '通过') {
        return 'checkedSucceed';
      }
      if (this.statusDescription === '未审核') {
        return 'unChecked';
      }
      if (this.statusDescription === '审核中') {
        return 'checking';
      }
      if (this.statusDescription === '已禁止') {
        return 'checkForbidden';
      }
      if (this.statusDescription === '未知') {
        return 'unKnown';
      }
      return 'unKnown';
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'edit' });
  },
  mounted() {
    this.spinning = true;
    this.handleGet();
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          const parameter = values;
          parameter.developerId = this.developerId;
          parameter.businessLicenseImg = this.businessLicenseImg;
          parameter.companyName = this.companyName;
          if (this.developerId && this.developerId.length > 0) {
            uploadDeveloper(parameter).then((res) => {
              if (res && res.success && res.result) {
                this.$message.success('修改成功');
                this.spinning = true;
                this.handleGet();
              } else {
                this.$message.error((res && res.errorMessage) || '修改失败，请重试');
              }
            });
          } else {
            createDeveloper(parameter).then((res) => {
              if (res && res.success && res.result) {
                this.developerId = res.result;
                this.$message.success('新增成功');
                this.spinning = true;
                this.handleGet();
              } else {
                this.$message.error((res && res.errorMessage) || '创建失败，请重试');
              }
            });
          }
        }
      });
    },
    handleCancel() {
      this.isModify = false;
    },
    handleUploadFileChange(info) {
      if (info.file.status !== 'uploading') {
        const res = info.file.response;
        if (res.success) {
          this.businessLicenseImg = res.result;
        } else {
          this.$message.error(`${(res && res.errorMessage) || '上传失败，请重试。'}`);
        }
      }
    },
    handleGet() {
      getDeveloper().then((res) => {
        this.spinning = false;
        if (res && res.success) {
          if (res.result) {
            const developerInfo = res.result;
            this.hasOperation = developerInfo.hasOperation === 1;
            this.companyName = developerInfo.organName;
            if (developerInfo.developerId) {
              this.hasDeveloper = true;
              this.isModify = false;
              this.developerId = developerInfo.developerId;
              this.address = developerInfo.address;
              this.businessLicense = developerInfo.businessLicense;
              this.corporation = developerInfo.corporation;
              this.contactPhone = developerInfo.contactPhone;
              this.email = developerInfo.email;
              this.vaildStatus = developerInfo.vaildStatus;
              this.statusDescription = developerInfo.statusDescription;
              this.businessLicenseImg = developerInfo.businessLicenseImg;
            } else {
              this.hasDeveloper = false;
              this.isModify = true;
            }
          } else {
            this.$message.error(`${(res && res.errorMessage) || '读取数据失败，请重试。'}`);
          }
        } else {
          this.$message.error(`${(res && res.errorMessage) || '读取数据失败，请重试。'}`);
        }
      });
    },
    handleUpdate() {
      setTimeout(() => {
        this.form.setFieldsValue({ address: this.address });
        this.form.setFieldsValue({ businessLicense: this.businessLicense });
        this.form.setFieldsValue({ corporation: this.corporation });
        this.form.setFieldsValue({ contactPhone: this.contactPhone });
        this.form.setFieldsValue({ email: this.email });
      }, 1);
      this.isModify = true;
    },
    handleGoToMyService() {
      this.$router.push({
        path: '/my-app/my-service',
      });
    },
  },
};
</script>

<style lang="less" scoped>
  .developer-page {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
    /deep/ .ant-spin-nested-loading {
      height: 100%;
      padding-top: 0;
      overflow-y: auto;
    }
    /deep/ .ant-spin-container {
      height: 100%;
      padding-top: 0;
      overflow-y: auto;
    }
    .un-developer-page {
      height: 100%;
      display: flex;
      flex-direction: column;
      padding: 20px;
      background: white;
      -webkit-align-items:center;
      align-items:center;
      -webkit-justify-content:center;
      justify-content:center;
      border:1px solid #ccc;
      .content {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
      }
      .child-div {
        text-align:center;
        align-items: center;
      }
  }

  }
  .form-page {
    height: 100%;
    padding: @padding-lg;
    background: white;
    border-radius: @border-radius-base;
    box-shadow: @box-shadow-base;
    overflow-y: auto;
    .title {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
      float: left;
      margin-right: 12px;
    }
    .edit {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 66px;
      height: 24px;
      padding: 6px 8px;
      background: #FFFFFF;
      border: 1px solid rgba(0,0,0,0.15);
      border-radius: 4px;
      cursor: pointer;
    }
    /deep/ .ant-col-2 {
      width: 115px;
    }
    .viewPage {
      /deep/ .ant-form-item {
        margin-bottom: -4px;
      }
      /deep/ .ant-col-2 {
        width: 105px;
      }
      /deep/ .ant-col-22 {
        width: 621px;
      }
    }
    .save {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 65px;
      height: 32px;
      background: #147FFA;
      border-radius: 6px;
      color: #FFFFFF;
      cursor: pointer;
    }
    .cancel {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 65px;
      height: 32px;
      background: #FFFFFF;
      border: 1px solid rgba(221,223,228,1);
      border-radius: 6px;
      cursor: pointer;
    }
  }
  .checkedSucceed {
    margin-left: 8px;
    color: #52C41A;
  }
  .unChecked {
    color: #000000;
  }
  .checking {
    color: #000000;
  }
  .checkForbidden {
    color: #F5222D;
  }
  .unKnown {
    color: #FAAD14;
  }
</style>
